export class ResetPasswordRouter {
    
    static getRoute(): string {
        return "/reset-password/:token"
    }

}